import { Document } from "../models";
import { DocumentSystem } from "../models/DocumentSystem";
import { DocumentVersion } from "../models/DocumentVersion";
import { UserDto } from "../services/generated";

export const mapDocumentToDocumentSystem = (document: Document) => {
  return new DocumentSystem({
    order: undefined as any as number,
    active: true,
    auditable: false,
    approved: document.approved,
    id: document.id,
    link: document.link,
    deleted: document.deleted,
    version: document.version,
    approvedBy: document.approvedBy,
    documentId: document.documentId,
    documentKind: document.documentKind,
    editStatus: document.editStatus,
    function: document.function,
    inReview: document.inReview,
    isOutdated: document.isOutdated,
    isLatestVersion: document.isLatestVersion,
    languageCode: document.languageCode,
    lifecycleStatus: document.lifecycleStatus,
    name: document.name,
    ownerProcessId: document.ownerProcessId,
    prepared: document.prepared,
    relevantToId: document.relevantToId,
    relevantTo: document.relevantTo,
    reviewedBy: document.reviewedBy,
    revisionId: document.revisionId,
    securityLevel: document.securityLevel,
    specialities: document.specialities,
    title: document.title,
    titleEn: document.titleEn,
    url: document.url,
    operatingUnit: document.operatingUnit,
    projectSizeCategories: document.projectSizeCategories,
    industries: document.industries,
    contentType: document.contentType,
    documentOwner: document.documentOwner,
    businessLines: document.businessLines,
    keyWords: document.keyWords,
    nextConfirmationDate: document.nextConfirmationDate
  });
}

export const mapNewItemToChangedItem =(document: Document) => {
  return new DocumentVersion({
    order: undefined as any as number,
    active: true,
    auditable: false,
    approved: document.approved,
    nextConfirmationDate: document.nextConfirmationDate,
    id: document.id,
    link: document.link,
    deleted: document.deleted,
    version: document.version,
    approvedBy: document.approvedBy,
    documentId: document.documentId,
    documentKind: document.documentKind,
    editStatus: document.editStatus,
    function: document.function,
    inReview: document.inReview,
    isOutdated: document.isOutdated,
    isLatestVersion: document.isLatestVersion,
    languageCode: document.languageCode,
    lifecycleStatus: document.lifecycleStatus,
    name: document.name,
    isFavorite: null,
    ownerProcessId: document.ownerProcessId,
    prepared: document.prepared,
    relevantToId: document.relevantToId,
    relevantTo: document.relevantTo,
    reviewedBy: document.reviewedBy,
    revisionId: document.revisionId,
    securityLevel: document.securityLevel,
    specialities: document.specialities,
    title: document.title,
    titleEn: document.titleEn,
    url: document.url,
    operatingUnit: document.operatingUnit,
    projectSizeCategories: document.projectSizeCategories,
    relativeUrl: document.relativeUrl,
    industries: document.industries,
    contentType: document.contentType,
    documentOwner: document.documentOwner,
    created: '',
    createdBy: undefined as any as UserDto,
    modified: null,
    modifiedBy: undefined as any as UserDto,
    businessLines: document.businessLines,
    keyWords : document.keyWords
  });
}